import { InputAdornment, CircularProgress } from '@material-ui/core';

const LoadingInputEndAdornment = ({ loading = false }) =>
  loading ? (
    <InputAdornment position="start">
      <CircularProgress color="inherit" size={25} />
    </InputAdornment>
  ) : null;

export default LoadingInputEndAdornment;
